import React from 'react';

import TaskTypeIcon from '../../../../../../core/gd-components/icons/task-icon/task-icon';
import InfoPanelRow from "../../../../../../core/gd-ui/ip-section-row/info-panel-row";
import FieldFormElement from "../../../../../fields3/render/form-elemnent";
import FormModel from "../../../../../gd-form/common/form-model-manager";
import UserAssignment_Fields from "../../../model/fields";
import FormFieldError from "../../../../../gd-form/common/form-error/form-field-error";
import Task from "../../../../../model2/task/task";
import FormRowFlex from "../../../../../gd-form/form/form-flex/row";
import ItemId from "../../../../../gd-ui/id/item-id";

type Props = {
    form        : FormModel
    userOptions : Options
    tasks       : Task[] | null
}

export default class ReassignUserTasks extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    renderTasksList = () => {

        const tasksReassignToField = new UserAssignment_Fields().tasksReassignUserId

        tasksReassignToField.options = this.props.userOptions

        const tasksGroupedByProject = _.chain(this.props.tasks)
                .groupBy('projectId')
                .toPairs()
                .map((g)=>{
                    const project = gd.session.projects.get(g[0]);
                    return {
                        'projectId': g[0],
                        'projectName': project ? project.name : "0",
                        'items': _.sortBy(g[1],i=>i.title.toLowerCase())
                    };
                })
                .sortBy('projectName')
                .value();

        return (
            <>
                {!_.isEmpty(tasksGroupedByProject) && (
                    <div className="ui5-list m-t-10 m-l-25">
                        {tasksGroupedByProject.map(group=> {
                            return group.items.map((t, key: number)=> {
                                const taskType = gd.session.taskTypes.get(t.taskTypeId);

                                return (
                                    <div key={key} className="row">
                                        <div className="cell h-40 p-0">
                                            {/*{taskType && <TaskTypeIcon className="ui5-ico-14 m-r-10" icon={taskType.icon} hint={false}/>}*/}
                                            <ItemId className   = "m-r-10"
                                                    itemId      = {t.shortId}
                                                    itemUrl     = "t/"
                                                    itemUrlId   = {t.id}
                                                    itemName    = "Task"
                                                    copyId      = {true}
                                                    copyUrl     = {true} />

                                            <div className="ui5-txt-default max-w-300">{t.title}</div>
                                        </div>
                                    </div>
                                )
                            })
                        })}
                    </div>
                )}

                <FormRowFlex label="Re-assign to" width={140} className="m-t-15 p-l-25">
                    <div className="flex-column-left-top">
                        <FieldFormElement field={tasksReassignToField} form={this.props.form} className="w-300"/>
                        <FormFieldError form={this.props.form} field={tasksReassignToField}/>
                    </div>
                </FormRowFlex>
            </>
        )
    };

    render() {
        if (!this.props.tasks || this.props.tasks.length < 1) return false;

        return (
            <>
                <div className="ui5-txt-default txt-bold m-t-20 m-l-25">Tasks</div>
                {this.renderTasksList()}
            </>
        )
    }
}
